(function(angular){
	'use strict';
	
	angular.module('historicalPerformanceChartModule', [
		'BaseConfig', 
		'highChartsModule'
	]);

})(window.angular);

